import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/layout/AdminSidebar";
import AdminTopbar from "../components/layout/AdminTopbar";

const shellStyle: React.CSSProperties = {
  minHeight: "100vh",
  background: "var(--background)",
  color: "var(--text-primary)",
  display: "flex",
};

const contentShellStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  padding: "24px",
};

const innerContentStyle: React.CSSProperties = {
  width: "100%",
};

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const handleToggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div style={shellStyle}>
      <AdminSidebar collapsed={collapsed} />

      <div style={contentShellStyle}>
        <AdminTopbar
          collapsed={collapsed}
          onToggleSidebar={handleToggleSidebar}
        />

        <main style={mainStyle}>
          <div style={innerContentStyle}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;